import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  allOrganiationReports,
  organiationReports,
  createOrganiationReports,
  deleteOrganiationReports,
  updateOrganiationReports,
  allOrganiationSingleReports,
  emailOrgReport,
} from "../../../api/organizationReports_api";

export const allOrganiationReportsAction = createAsyncThunk(
  "organizationReports/allRepors",
  async (values, { rejectWithValue, getState }) => {
    try {
      const organization = await allOrganiationReports(values);
      return organization.data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const allOrganiationSingleReportsAction = createAsyncThunk(
  "organizationReports/singleRecord",
  async (values, { rejectWithValue, getState }) => {
    try {
      const organization = await allOrganiationSingleReports(values);
      return organization.data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const createOrganiationReportsAction = createAsyncThunk(
  "organizationReports/create",
  async (values, { rejectWithValue, getState }) => {
    try {
      const organization = await createOrganiationReports(values);
      return organization.data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);

export const updateOrganiationReportsAction = createAsyncThunk(
  "organizationReports/update",
  async (values, { rejectWithValue, getState }) => {
    try {
      const organization = await updateOrganiationReports(values);
      return organization.data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);


export const emailOrgReportAction = createAsyncThunk(
  "organizationReports/email",
  async (values, { rejectWithValue, getState }) => {
    try {
      const response = await emailOrgReport(values);
     return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);


export const deleteOrganiationReportsAction = createAsyncThunk(
  "organizationReports/delete",
  async (values, { rejectWithValue, getState }) => {
    try {
      const organization = await deleteOrganiationReports(values);
      return organization.data;
    } catch (error) {
      return rejectWithValue(error.message || "something went wrong");
    }
  }
);


